import { Box } from '@mui/material';
import SiteImportStepper from '../components/import/SiteImportStepper';

const SiteImportPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <SiteImportStepper />
    </Box>
  );
};

export default SiteImportPage;
